import { MessageCircle } from "lucide-react";
import { waLink } from "./constants";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink("Hi Kieran, I'd like to chat about a mortgage.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with Kieran on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    >
      <span className="hidden sm:block max-w-0 overflow-hidden group-hover:max-w-[160px] transition-all duration-500 rounded-full bg-[#03222D]/90 backdrop-blur border border-white/10 text-xs font-semibold text-white whitespace-nowrap group-hover:px-4 py-2.5">
        Chat with Kieran
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/30 transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <MessageCircle size={24} className="relative text-[#03222D]" />
      </span>
    </a>
  );
}
